import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {Chip as MuiChip, styled, ChipProps} from '@mui/material';

const Chip = styled(MuiChip)(({theme, sx}: any) => ({
  background: '#eef2f6',
  padding: theme.spacing(0.25, 1.25),
  width: 'fit-content',
  height: 'auto',
  '*': {
    color: sx.color ? sx.color : theme.palette.text.secondary,
    fontWeight: 400,
    // fontSize: 12,
  },
  '.MuiChip-label': {
    padding: theme.spacing(0, 0.25),
  },
  '&.MuiChip-deletable': {
    padding: theme.spacing(0.5, 1),
    paddingRight: 0,
    '.MuiChip-label': {
      paddingRight: theme.spacing(1.5),
      color: sx.color ? sx.color : theme.palette.text.primary,
    },
  },
}));
export default ({sx, ...props}: ChipProps) => {
  const IsLarge = useIsLargeDevice();
  const fontSize = IsLarge ? 12 : 10;
  return (
    <Chip {...props} sx={{fontSize, maxWidth: {xxs: 200, md: 300}, ...sx}} />
  );
};
